<template>
	<div class="float-none">
		<b-alert show variant="secondary">
			<div class="d-flex justify-content-between align-items-center">
				<div>
					{{uplimit_reason.date1}} {{uplimit_reason.market_type}} {{uplimit_reason.up_limit_desc}}
				</div>
				<div>
					<b-button size="sm" variant="link" @click="toggleHistory">历史</b-button>
				</div>
			</div>
			<div class="mt-1">{{uplimit_reason.reason}}</div>
		</b-alert>

		<div v-if="showHistory" class="border rounded p-2">
			<div class="d-flex justify-content-between align-items-center mb-2">
				<div>历史涨停原因（每页10条）</div>
				<div>
					<b-button size="sm" class="mr-1" :disabled="historyPage<=1 || loadingHistory" @click="prevPage">上一页</b-button>
					<b-button size="sm" :disabled="!hasNext || loadingHistory" @click="nextPage">下一页</b-button>
				</div>
			</div>
			<div v-if="loadingHistory" class="d-flex align-items-center p-2">
				<b-spinner small class="mr-2"></b-spinner>
				<span>载入历史...</span>
			</div>
			<div v-else>
				<div v-if="historyItems.length===0" class="text-muted">暂无历史记录</div>
				<div v-for="it in historyItems" :key="it.id" class="mb-2">
					<div class="d-flex justify-content-between">
						<div>
							<strong>{{it.date1}}</strong> {{it.market_type}} {{it.up_limit_desc}}
						</div>
						<div class="text-muted">板高：{{it.up_limit_keep_times}} 封单额：{{formatMoney(it.fengdan_money)}} 成交额：{{it.amount+'亿'}}
						</div>
					</div>
					<div class="text-secondary">{{it.reason}}</div>
					<hr class="my-1"/>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
import { request_zzquant } from "network/request.js"

export default {
        props: {
            symbol_code: String,
            date_mark: String
        },
        computed: {
            hasNext(){ return this.historyPage * this.pageSize < this.total }
        },
        components: {

        },
        watch: {
            symbol_code: 'refresh',
            date_mark: 'refresh'
        },
		data() {
            return {
                uplimit_reason: {},
                showHistory: false,
                historyPage: 1,
                pageSize: 10,
                total: 0,
                historyItems: [],
                loadingHistory: false
            }
        },
        mounted() {
            this.refresh();
        },
        methods: {
            refresh() {
                if(!this.symbol_code){ this.uplimit_reason = {}; return }
                const dateParam = this.date_mark ? `?date=${this.date_mark}` : ''
                request_zzquant({
                    url: `open/stock/uplimit/reason/${this.symbol_code}${dateParam}`
                }).then(res=>{
                    const d = res && res.data && res.data.data ? res.data.data : null
                    this.uplimit_reason = d || {}
                }).catch(()=>{ this.uplimit_reason = {} })
                if(this.showHistory){ this.loadHistory() }
            },
            toggleHistory(){
                this.showHistory = !this.showHistory
                if(this.showHistory){ this.historyPage = 1; this.loadHistory() }
            },
            loadHistory(){
                if(!this.symbol_code){ this.historyItems=[]; this.total=0; return }
                this.loadingHistory = true
                request_zzquant({ url: `open/stock/uplimit/reason/history/${this.symbol_code}?page=${this.historyPage}&pageSize=${this.pageSize}` })
                  .then(res=>{
                    const d = res && res.data && res.data.data ? res.data.data : {}
                    const items = d && d.items ? d.items : []
                    const total = d && d.total ? d.total : 0
                    this.historyItems = Array.isArray(items) ? items : []
                    this.total = Number(total)||0
                  })
                  .catch(()=>{ this.historyItems = []; this.total = 0 })
                  .finally(()=>{ this.loadingHistory = false })
            },
            nextPage(){ if(this.hasNext){ this.historyPage += 1; this.loadHistory() } },
            prevPage(){ if(this.historyPage>1){ this.historyPage -= 1; this.loadHistory() } },
            formatMoney(v){ const n = Number(v)||0; return n>0 ? (n/100000000).toFixed(2)+'亿' : '-' }

        }
    }
</script>

<style>
</style>
